import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from './store';

export function AdminOnlyRoute(): JSX.Element {
  const user = useAuthStore((s) => s.user);
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== 'ADMIN') return <Navigate to="/customers" replace />;
  return <Outlet />;
}
